import { render, staticRenderFns } from "./DOE.vue?vue&type=template&id=9845b85e&scoped=true&"
import script from "./DOE.vue?vue&type=script&lang=js&"
export * from "./DOE.vue?vue&type=script&lang=js&"
import style0 from "./DOE.vue?vue&type=style&index=0&id=9845b85e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9845b85e",
  null
  
)

export default component.exports